import { Message, Action, ActionType } from "@progress/kendo-react-conversational-ui";
import { process, State, DataResult, FilterDescriptor } from "@progress/kendo-data-query";

export const user = {
  id: 1,
};

export const bot = {
  id: 0,
};

export interface ActionWithFilter extends Action {
  filter: FilterDescriptor;
}

export const buildMessageTree = (props: any[]): Message[] => {
  //allMessages[2].suggestedActions = ;

  const mechanisms: string[] = [];
  props.forEach(element => {
    const splitted = element.mechanism.split(', ') as string[];
    mechanisms.push(...splitted.filter(x => !(x === null || x.match(/^ *$/) !== null)));
  });

  let uniqueMechanisms = [...new Set(mechanisms)]

  allMessages[3].suggestedActions = uniqueMechanisms.map((data) => {
    return { type: "reply", value: data, filter: { operator: "contains", value: data, field: "mechanism" } } as ActionWithFilter;
  });


  const thematics: string[] = [];
  props.forEach(element => {
    const splitted = element.thematics.split(', ') as string[];
    thematics.push(...splitted.filter(x => !(x === null || x.match(/^ *$/) !== null)));
  });

  let uniqueThematics = [...new Set(thematics)]

  allMessages[4].suggestedActions = uniqueThematics.map((data) => {
    return { type: "reply", value: data, filter: { operator: "contains", value: data, field: "thematics" } } as ActionWithFilter;
  });

  return allMessages;
};

export const allMessages: Message[] = [
  {
    author: bot,
    text: "Szia! Gamer Géza vagyok! Ha válaszolsz nekem pár kérdésre, megpróbálom megtalálni számodra az ideális társasjátékot!",
    suggestedActions: [
      { value: "Kezdjük!", type: "reply", },
      //{ title: "A sample link", value: "#link", type: "openUrl", },
      //{ title: "Place a call", value: "555-123-456", type: "call", },
      //{ title: "A custom action", value: "Custom action clicked", type: "alert", },
    ],
  },
  // {
  //   author: bot,
  //   text: "Kinek vásárolnál játékot?",
  //   suggestedActions: [
  //     { type: "reply", value: "Magamnak" },
  //     { type: "reply", value: "Ajándékba" },
  //   ],
  // },
  // {
  //   author: bot,
  //   text: "Kik játszanak majd a játékkal?",
  //   suggestedActions: [
  //     { type: "reply", value: "Család (felnőttek+gyerekek)" },
  //     { type: "reply", value: "Gyerekek" },
  //     { type: "reply", value: "Baráti társaság (14 éves kor felett)" },
  //   ],
  // },
  {
    author: bot,
    text: "Általában hányan játszanak majd a játékkal?",
    suggestedActions: [
      { type: "reply", value: "Egyedül", filter: { field: "numberOfPlayers", operator: "eq", value: "1" } } as ActionWithFilter,
      { type: "reply", value: "2 fő", filter: { field: "numberOfPlayers", operator: "eq", value: "2" } },
      { type: "reply", value: "3 fő", filter: { field: "numberOfPlayers", operator: "eq", value: "3" } },
      { type: "reply", value: "4 fő", filter: { field: "numberOfPlayers", operator: "eq", value: "4" } },
      { type: "reply", value: "5 fő", filter: { field: "numberOfPlayers", operator: "eq", value: "5" } },
      { type: "reply", value: "5-nél többen", filter: { field: "numberOfPlayers", operator: "eq", value: "6" } },
    ],
  },
  {
    author: bot,
    text: "Mennyi idős a legfiatalabb leendő játékos?",
    suggestedActions: [
      { type: "reply", value: "5 éves kor alatt" },
      { type: "reply", value: "5 - 8 éves kor között" },
      { type: "reply", value: "9 - 11 éves kor között" },
      { type: "reply", value: "12 - 14 éves kor között" },
      { type: "reply", value: "14 éves kor fölött" },
    ],
  },
  {
    author: bot,
    text: "Milyen típusú játékok érdekelnek?",
    suggestedActions: [
      { type: "reply", value: "Kommunikáció, asszociáció" },
      { type: "reply", value: "Stratégia" },
      { type: "reply", value: "Kooperatív" },
      { type: "reply", value: "Titkos szerep, blöffölés" },
      { type: "reply", value: "Kártya" },
      { type: "reply", value: "Absztrakt, logikai" },
      { type: "reply", value: "Gyorsasági, reakció" },
      { type: "reply", value: "Ügyességi" },
    ],
  },
  {
    author: bot,
    text: "Milyen témájú játékot szeretnél?",
    suggestedActions: [
      { type: "reply", value: "Sci-fi" },
      { type: "reply", value: "Horror" },
      { type: "reply", value: "Történelem" },
      { type: "reply", value: "Természet, Állatok" },
      { type: "reply", value: "Városok, Építkezés" },
      { type: "reply", value: "Fantasy, kaland" },
      { type: "reply", value: "Humor" },
      { type: "reply", value: "Bűnügyek, Krimi" },
      { type: "reply", value: "Western" },
      { type: "reply", value: "Gazdaság, Gazdálkodás" },
    ],
  },
  // {
  //   author: bot,
  //   text: "Végezetül kérlek áruld el, hogy játszottál-e már az alábbi játékokkal?",
  //   suggestedActions: [
  //     { type: "reply", value: "Monopoly" },
  //     { type: "reply", value: "Dixit" },
  //     { type: "reply", value: "Ticket to Ride" },
  //     { type: "reply", value: "Bang!" },
  //     { type: "reply", value: "Catan telepesei" },
  //     { type: "reply", value: "Carcassonne" },
  //     { type: "reply", value: "Pandemic" },
  //     { type: "reply", value: "7 csoda" },
  //     { type: "reply", value: "A Mars terraformálása" },
  //     { type: "reply", value: "Korokon át" },
  //   ],
  // },
  {
    author: bot,
    text: "A válaszaid alapján szerintem az alábbi játékokkal remekül szórakoznál!",
    suggestedActions: [
      { type: "reply", value: "Köszi!" },
    ],
  },
];
